import {
  PRESET_OPTIONS_WITH_COMPARISON,
  PresetKey,
} from "@/components/v2/DatePicker/constants";

import type { DateRange } from "react-day-picker";

import moment from "moment";

export const getTimeFilter = (dateRange?: DateRange) => {
  if (!dateRange) return undefined;

  return {
    startTimeISO: dateRange.from!.toISOString(),
    endTimeISO: dateRange.to!.toISOString(),
  };
};

const presetHasComparison = (datePreset: PresetKey) =>
  PRESET_OPTIONS_WITH_COMPARISON.includes(datePreset);

export const getComparisonTimeFilter = ({
  datePreset,
  dateRange,
  timezone,
}: {
  datePreset?: PresetKey;
  dateRange?: DateRange;
  timezone: string;
}) => {
  if (
    !datePreset ||
    !presetHasComparison(datePreset) ||
    !dateRange?.from ||
    !dateRange?.to
  ) {
    return undefined;
  }

  const from = moment.tz(dateRange.from, timezone);
  const to = moment.tz(dateRange.to, timezone);

  const comparisonTo = from.clone().subtract(1, "day").endOf("day");
  let comparisonFrom;

  switch (datePreset) {
    case PresetKey.PrevMonth: {
      comparisonFrom = from.clone().subtract(1, "month").startOf("day");
      break;
    }
    case PresetKey.PrevQuarter: {
      comparisonFrom = from.clone().subtract(3, "months").startOf("day");
      break;
    }
    case PresetKey.PrevYear: {
      comparisonFrom = from.clone().subtract(1, "year").startOf("day");
      break;
    }
    case PresetKey.Last12m: {
      comparisonFrom = from.clone().subtract(12, "months").startOf("day");
      break;
    }
    default: {
      const durationDays = to.diff(from, "days");

      comparisonFrom = comparisonTo
        .clone()
        .subtract(durationDays, "days")
        .startOf("day");
    }
  }

  return {
    startTimeISO: comparisonFrom.toISOString(),
    endTimeISO: comparisonTo.toISOString(),
  };
};
